import Vue from 'vue'
import VueRouter from 'vue-router'
import {routes} from './routes'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes
})

function getUserIdRole() {
  try {
    const data = localStorage.getItem('vuex');
    if (!data) return null;

    const parsedData = JSON.parse(data);
    return parsedData.roleid;
  } catch (e) {
    console.error("No data in localStorage", e);
    return null;
  }
}

router.beforeEach((to, from, next) => {
  const roleId = getUserIdRole();
  const isAdminPath = to.path.includes('/systemadmin') || to.path.includes('/sysadmin');

  if (isAdminPath && roleId !== 1) {
    next({ name: 'forbidden' });
  } else {
    next();
  }
});

export default router
